import {
    Action,
    Store,
    ThunkAction,
    configureStore,
    combineReducers
} from '@reduxjs/toolkit'
import { clear, load, save } from 'redux-localstorage-simple'
import * as Sentry from "@sentry/react";
import {guiSlice} from "./gui";
import {apiKeyManagementApi} from "./api-key-management-api";

const namespace = 'key-portal'

const preloadedState = load({
    states: [guiSlice.name],
    namespace
}) as RootState

if (preloadedState?.gui?.version !== guiSlice.getInitialState().version) {
    clear({
        namespace
    })
}

const mainReducer = combineReducers({
    [guiSlice.name]: guiSlice.reducer,
    [apiKeyManagementApi.reducerPath]: apiKeyManagementApi.reducer
})

const sentryReduxEnhancer = Sentry.createReduxEnhancer()

const store: Store = configureStore({
    reducer: mainReducer,
    middleware: (getDefaultMiddleware) => {
        return getDefaultMiddleware({
            serializableCheck: false,
        }).concat(
            save({
                states: [guiSlice.name],
                namespace
            })
        ).concat(
            apiKeyManagementApi.middleware
        )

    },
    enhancers: (getDefaultEnhancers) => {
        return getDefaultEnhancers().concat(sentryReduxEnhancer)
    },
    preloadedState: preloadedState
});


type RootState = ReturnType<typeof store.getState>
type AppDispatch = typeof store.dispatch
type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>

export { store }
export type { AppDispatch, RootState, AppThunk }